import { apiWS as apiСonstructor } from "../libs/apiWS.mjs";
class SessionAPI {
  constructor(url) {
    this._api = apiСonstructor(url);
  }
  async getToken(callback) {
    try {
      this._api.send({ function: "getToken" }, callback);
    } catch (er) {
      console.log("Error", er);
      throw er;
    }
  }
  async sendMessage(data) {
    try {
      let result = await this._api.send({ function: "sendMessage", body: { ...data } });
      return result;
    } catch (er) {
      console.log("Error", er);
      throw er;
    }
  }
  async getMessages(callback) {
    try {
      let result = await this._api.send({ function: "getMessages" }, callback);
      return result;
    } catch (er) {
      console.log("Error", er);
      throw er;
    }
  }
  addEventGetMessage(callback) {
    try {
      this._api.addEvent("getMessages", callback);
    } catch (er) {
      console.log("Error", er);
      throw er;
    }
  }
  addEventTakeMessage(callback) {
    try {
      this._api.addEvent("sendMessage", callback);
    } catch (er) {
      console.log("Error", er);
      throw er;
    }
  }
  async uploadFile(id, photoBuffer) {
    try {
      let result = await this._api.send({ function: "uploadFile", body: { id, photoBuffer } });
      return result;
    } catch (er) {
      console.log("Error", er);
      throw er;
    }
  }
  addEventUploadFile(callback) {
    try {
      this._api.addEvent("uploadFile", callback);
    } catch (er) {
      console.log("Error", er);
      throw er;
    }
  }
  async synthesizeSpeech(id, text) {
    try {
      let result = await this._api.send({
        function: "synthesizeSpeech",
        body: { id, text },
      });
      return result;
    } catch (er) {
      console.log("Error", er);
      throw er;
    }
  }
  addEventSynthesizeSpeech(callback) {
    try {
      this._api.addEvent("synthesizeSpeech", callback);
    } catch (er) {
      console.log("Error", er);
      throw er;
    }
  }
}
export const sessionAPI = new SessionAPI(process.env.REACT_APP_WS_URL);
